import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  Tooltip,
  CartesianGrid,
  XAxis,
  YAxis,
} from "recharts";

type StockMovementPoint = {
  date: string;
  stockIn: number;
  stockOut: number;
};

interface StockMovementChartProps {
  data: StockMovementPoint[];
}

const StockMovementChart: React.FC<StockMovementChartProps> = ({ data }) => {
  return (
    <div className="mt-4 h-44 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="stockInFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#A5B4FC" stopOpacity={0.5} />
              <stop offset="100%" stopColor="#A5B4FC" stopOpacity={0.05} />
            </linearGradient>
            <linearGradient id="stockOutFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#C7D2FE" stopOpacity={0.4} />
              <stop offset="100%" stopColor="#C7D2FE" stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#E5E7EB" vertical={false} />
          <XAxis dataKey="date" hide />
          <YAxis hide />
          <Tooltip
            contentStyle={{
              borderRadius: "8px",
              borderColor: "#E5E7EB",
              fontSize: "12px",
            }}
            labelStyle={{ fontWeight: 600 }}
          />
          <Area
            type="monotone"
            dataKey="stockIn"
            stroke="#6366F1"
            strokeWidth={2}
            fill="url(#stockInFill)"
            dot={false}
          />
          <Area
            type="monotone"
            dataKey="stockOut"
            stroke="#818CF8"
            strokeWidth={2}
            fill="url(#stockOutFill)"
            dot={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StockMovementChart;
